var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, computed, runInAction, makeObservable, override } from 'mobx';
import { deserialize } from '../../../../utils/serializr/serializr';
import { SSMLLanguage } from '../../../learnware/LearnwareEnums';
import { Snd } from '../snd/Snd';
import { xa } from '../../../../utils/xa/xa';
import { memoize } from '../../../../utils/mobx/decorators/memoize';
import { editable } from '../../../../utils/mobx/decorators/editable';
import { runtime } from '../../../runtime/Runtime';
export class TTS extends Snd {
    type = 'tts';
    ttsEngine = 'auto';
    ssml = '';
    lang = SSMLLanguage.DE;
    rate = 1;
    fileHashCode = '';
    isPreloaded = false;
    constructor(init) {
        super(init);
        makeObservable(this);
    }
    get trait() {
        return this.parent;
    }
    get isEmpty() {
        return this.ssml.length === 0;
    }
    static fromSerialized(ser = {}) {
        return deserialize(TTS, ser);
    }
    get hashCode() {
        return runtime.solidPackages.Exotic.classes.md5(this.ssml + this.lang + this.rate);
    }
    get src() {
        if (!this.isPreloaded) {
            this.isPreloaded = true;
            setTimeout(this.generateIfMissing);
        }
        return `/data2/tts/${this.hashCode}.mp3?version=${this.fileVersion}`;
    }
    get isGenerated() {
        return this.fileHashCode === this.hashCode;
    }
    generateIfMissing() {
        const a = document.createElement('audio');
        a.addEventListener('error', this.generateSnd, true);
        a.src = this.src;
        a.load();
    }
    async generateSnd(e) {
        if (this.ssml.length === 0)
            return;
        const success = await xa.audio.generateSndFromTTS({
            hashCode: this.hashCode,
            ssml: this.ssml,
            lang: this.lang,
            rate: this.rate,
        });
        if (success)
            runInAction(() => this.fileVersion++);
    }
    static get serializeInfo() {
        return {
            extends: Snd.serializeInfo,
            props: {
                mediumLabel: true,
                ssml: true,
                lang: true,
                rate: true,
                fileHashCode: true,
                ttsEngine: true,
            },
        };
    }
}
__decorate([
    editable()
], TTS.prototype, "ttsEngine", void 0);
__decorate([
    editable()
], TTS.prototype, "ssml", void 0);
__decorate([
    editable()
], TTS.prototype, "lang", void 0);
__decorate([
    editable()
], TTS.prototype, "rate", void 0);
__decorate([
    editable()
], TTS.prototype, "fileHashCode", void 0);
__decorate([
    computed
], TTS.prototype, "hashCode", null);
__decorate([
    override
], TTS.prototype, "src", null);
__decorate([
    action.bound
], TTS.prototype, "generateIfMissing", null);
__decorate([
    action.bound
], TTS.prototype, "generateSnd", null);
__decorate([
    memoize
], TTS, "serializeInfo", null);
